module.exports = __webpack_public_path__ + "bdcdd018aeea433b691132f93108f6d4.svg";